define('glu/grid/paginate/serverSidePager',['require','./pager'],function(require) {
    'use strict';

    var PagerView = require('./pager');

    return PagerView.extend({
        handleInputChange: function() {
            if (this.isClosed) {
                return;
            }
            this.updatePager();
            this.outputCollection.reset(this.inputCollection.models);
            this.updateChildViews();
        }
    });
});

